import PropTypes from 'prop-types'
import { View } from './View'

/**
 * Appkit4 Checkboxコンポーネントは
 * <a href="https://appkit.pwc.com/appkit4/content/checkbox?version=react&variation=selected" target="_blank">こちら</a>
 */
export const Checkbox = ({ ...props }) => {
    return <View {...props} />
}

Checkbox.propTypes = {
    /**
     * ラベル<font color="red">*</font>
     */
    label: PropTypes.string.isRequired,
    /**
     * 選択状態<font color="red">*</font>
     */
    checked: PropTypes.bool.isRequired,
    /**
     * ラベルのフォントサイズ
     */
    fontSize: PropTypes.number,
    /**
     * イベントハンドラー<br>
     *  (checked: boolean, event: React.SyntheticEvent) => void
     */
    onChange: PropTypes.func,
    /**
     * チェックボックスの値
     */
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    /**
     * スタイル変更用のクラス名
     */
    className: PropTypes.any
}

Checkbox.defaultProps = {
    label: '',
    fontSize: 12,
    checked: false
}
